import styled from 'styled-components'
import { Colors } from 'Styles/theme'

export default styled.div`
  width: 100%;
  border: 1px solid ${Colors.lavenderblue};
`
